import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Detail-panel section header that doubles as a collapse toggle, shared by the Project
 * Management > Transmittals pages.
 *
 * Same teal stui-detail-section-header bar every detail panel already uses, made clickable
 * with the generic stui-clickable cursor utility and a trailing chevron — the same
 * expand/collapse idiom the report viewer's step headers use, just without the numbered circle.
 */
const CollapsibleSectionHeader = ({ label, collapsed, onToggle }) => (
  <div
    className="stui-detail-section-header stui-clickable stui-row-between"
    onClick={onToggle}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onToggle();
      }
    }}
  >
    <span>{label}</span>
    {collapsed ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
  </div>
);

export default CollapsibleSectionHeader;
